export const LOCATIONS_EXPORT_HEADS = [
  { id: "id", label: "ID" },
  { id: "code", label: "Código" },
  { id: "responsible", label: "Responsável" },
  { id: "address", label: "Endereço" },
  { id: "email", label: "Email" },
  { id: "phone", label: "Telefone" },
  { id: "latitude", label: "Latitude" },
  { id: "longitude", label: "Longitude" },
  { id: "createdAt", label: "Criado em" },
  { id: "updatedAt", label: "Atualizado em" },
];
